// extracted by mini-css-extract-plugin
module.exports = {"Active":"Switch_Active__2vNaO"};